// Handles webpack chunk loading failures

const reloadOnce = () => {
  const alreadyReloaded = sessionStorage.getItem("chunk-reload");

  if (!alreadyReloaded) {
    sessionStorage.setItem("chunk-reload", "true");
    window.location.reload();
  }
};

const isChunkError = (msg) => {
  return (
    msg && (msg.includes("Loading chunk") || msg.includes("ChunkLoadError"))
  );
};

// Catch script loading errors (e.g., chunk not found)
window.addEventListener("error", (e) => {
  if (isChunkError(e.message)) {
    reloadOnce();
  }
});

// Catch dynamic import / lazy loading failures
window.addEventListener("unhandledrejection", (e) => {
  if (isChunkError(e.reason?.message)) {
    reloadOnce();
  }
});
